import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Industry() {

    const navigate = useNavigate()
    const industries = [
        { name: "Asset Management", image: "images/dataa.svg", path: "/industries/asset-management" },
        { name: "Banking", image: "images/dbank.svg", path: "/industries/banking" },
        { name: "Capital Markets", image: "images/dmarket.svg", path: "/industries/capitalmarkets" },
        { name: "Healthcare", image: "images/heal.svg", path: "/industries/healthcare" },
        { name: "Manufacturing", image: "images/manufact.svg", path: "/industries/manufacturing" },
        { name: "Transportation", image: "images/tranport.svg", path: "/industries/transportation" },
        { name: "Facilities Management", image: "images/assetm.svg", path: "/industries/facilities-management" },
    ];
    const caseStudies = [
        {
            title: "Cloud migration saves money for health insurer",
            logo: "unilogo",
            image: "images/din.jpg",
            overlayColor: "rgba(0, 191, 255, 0.6)", // Cyan
        },
        {
            title: "Remote support center for semiconductor provider",
            logo: "jarguar",
            image: "images/din.jpg",
            overlayColor: "rgba(0, 0, 255, 0.6)", // Blue
        },
        {
            title: "Subscription licensing unlocks spike in IT orders",
            logo: "ticketbox",
            image: "images/din.jpg",
            overlayColor: "rgba(128, 0, 128, 0.6)", // Purple
        },
    ];
    return (
        <>
            <div className="industry-container mb-5">
                <section className="industries-section">
                    <Container>
                        <Row className="mb-5">
                            <Col md={6}>
                                <h6 style={{ color: '#1dc2ef' }}>Industries We Serve</h6>
                                <h1>Managed IT services customized for your industry</h1>
                            </Col>
                            <Col md={6}>
                                <p style={{ color: '#9b9aad',paddingTop:'5%', textAlign:'justify'}}>
                                    The industry-specific solutions from DigiSoft provide the insights, frameworks, and guidelines your business needs to streamline and improve productivity. For any industry, DigiSoft offers custom solutions that have met requirements and regulations specific to that industry.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <div className="industries-grid">
                    {industries.map((industry, index) => (
                        <div className="industry-card" key={index} onClick={() => navigate(industry.path)}
                        style={{ cursor: "pointer" }}>
                            <div className="industry-image">
                                <img src={industry.image} alt={industry.name} />
                            </div>
                            <h5 style={{ marginBottom: '10px' }}>{industry.name}</h5>
                            {/* <p>Let us show you how our experience.</p> */}
                        </div>
                    ))}
                </div>
            </div>


            {/* Section 2: Case Studies */}
            {/* <section className="case-studies-section">
            <h6 style={{ color: '#1dc2ef',textAlign:'center' }}>CASE STUDIES</h6>
                <h2 style={{textAlign:'center',color:'white',paddingBottom:'10px'}}>We work with global brands</h2>
                <div className="case-studies-grid">
                    {caseStudies.map((caseStudy, index) => (
                        <div
                            className="case-study-card"
                            key={index}
                            style={{
                                backgroundImage: `url(${caseStudy.image}), linear-gradient(${caseStudy.overlayColor}, ${caseStudy.overlayColor})`,
                                backgroundBlendMode: "overlay", // Combines image and overlay color
                            }}
                        >
                            <div className="case-text">
                                <h3>{caseStudy.title}</h3>
                                <div className="case-logo">{caseStudy.logo}</div>
                            </div>
                        </div>
                    ))}
                </div>
                <Container>
                        <p className="it-solution mt-5">
                            Find out how companies succeed with us .{" "}
                            <a href="#explore">Read our case studies</a>
                        </p>
                    </Container>
            </section> */}

        </>
    )
}